const stores = [
    {
        name: 'areas',
        key: 'vision',
        indexes: ['code', 'modality', 'areaId', 'dataStatus'],
    },
    {
        name: 'users',
        key: 'userName',
        indexes: ['userName', 'dataStatus'],
    },
    {
        name: 'resources',
        key: 'vision',
        indexes: ['id', 'dataStatus'],
    },
    {
        name: 'configuration',
        key: 'vision',
        indexes: ['dataStatus'],
    },
    {
        name: 'orders',
        key: 'orderId',
        indexes: ['orderCode', 'dataStatus', 'vision'],
    },
    {
        name: 'picking',
        key: 'orderItemId',
        indexes: ['orderId', 'dataStatus', 'vision'],
    },
    {
        name: 'repicking',
        key: 'orderItemId',
        indexes: ['orderId', 'orderItemOriginId', 'dataStatus', 'vision'],
    },
    {
        name: 'suppliers',
        key: 'key',
        indexes: ['dataStatus', 'vision'],
    },
    {
        name: 'parts',
        key: 'key',
        indexes: ['dataStatus', 'vision'],
    },
    {
        name: 'InventoryLineList',
        key: 'id',
        indexes: ['id'],
    },
    {
        name: 'InventoryLineListDetail',
        key: 'id',
        indexes: ['id'],
    },
    {
        name: 'HISTORICOS',
        key: 'id',
        indexes: ['id'],
    },
    {
        name: 'inventories',
        key: 'id',
        indexes: ['dataStatus', 'vision'],
    },
    {
        name: 'lots',
        key: 'lotNumber',
        indexes: ['dataStatus', 'vision'],
    },
    {
        name: 'lotItems',
        key: 'lotItemId',
        indexes: ['dataStatus', 'vision'],
    },
    {
        name: 'readingLotItem',
        key: 'lotItemId',
        indexes: ['dataStatus', 'vision'],
    },
    {
        name: 'readingLotItemSendSim',
        key: 'lotItemId',
        indexes: ['dataStatus', 'vision'],
    },
    {
        name: 'readingLotItemCheckCloseLot',
        key: 'lotItemId',
        indexes: ['dataStatus', 'vision'],
    },
    {
        name: 'locations',
        key: 'id',
        indexes: ['dataStatus', 'id', 'entrycode', 'vision'],
    },
    {
        name: 'lineOrders',
        key: 'orderGroupId',
        indexes: ['orderGroupId', 'dataStatus', 'vision'],
    },
];

const version = 6;
const dbName = 'logistics-pwa-db';
let connection = null;
let close = null;

export default class ConnectionFactory {
    constructor() {
        throw new Error('Não é possível criar instâncias de ConnectionFactory');
    }

    static closeConnection() {
        if (connection) {
            Reflect.apply(close, connection, []);
            connection = null;
        }
    }

    static getConnection() {
        return new Promise((resolve, reject) => {
            const openRequest = window.indexedDB.open(dbName, version);
            openRequest.onupgradeneeded = (e) => {
                ConnectionFactory.createStores(e.target.result);
            };

            openRequest.onsuccess = (e) => {
                if (!connection) {
                    connection = e.target.result;
                    close = connection.close.bind(connection);
                    connection.close = () => {
                        throw new Error('Você não pode fechar diretamente a conexão');
                    };
                }
                resolve(connection);
            };
            openRequest.onerror = (e) => {
                reject(e.target.error.name);
            };
        });
    }

    static createStores(objConnection) {
        stores.forEach((store) => {
            if (objConnection.objectStoreNames.contains(store.name)) {
                objConnection.deleteObjectStore(store.name);
            }
            const objectStore = objConnection.createObjectStore(store.name, { keyPath: store.key });

            store.indexes.forEach((index) => {
                objectStore.createIndex(index, index);
            });
        });
    }
}
